import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Spinner } from 'components/atoms';

const NhisConsentFlow = lazy(() => import('./NhisConsentFlow'));

const NhisConsentRouter: React.FC = () => {
  return (
    <Suspense fallback={<Spinner size="Large" />}>
      <Routes>
        <Route path="consent/:token" element={<NhisConsentFlow />} />
      </Routes>
    </Suspense>
  );
};

export default NhisConsentRouter;
